import { createStyles } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import theme from '../../theme'

export const useCheckoutPageStyles = makeStyles(() =>
  createStyles({
    linksArea: {
      height: 50,
      display: 'flex',
      justifyContent: 'right',
    },

    linkInNew: {
      display: 'inline-flex',
      alignItems: 'center',
      textDecoration: 'underline',

      '& .MuiSvgIcon-root': {
        marginLeft: 4,
        fontSize: 14,
      },
    },
    descriptionArea: {
      marginBottom: 50,
    },
    boldLink: {
      textDecoration: 'underline',
    },
    addAddressButton: {
      lineHeight: 1,
      minheight: 0,
      padding: 0,
      verticalAlign: 'baseline',
      textDecoration: 'underline',
      color: 'black',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  })
)
